const toastr = require('toastr')
const $ = require('jquery')
const Vue = require('vue')
const R = require('ramda')

const transform = (type, value) => {
    switch (type) {
        case 'number': return parseInt(value)
        default: return value
    }
}

Vue.component('form-text', {
    props: {
        label: {
            type: String
        },
        placeholder: {
            type: String
        },
        iconClass: {
            type: String
        },
        model: {
            twoWay: true,
            default: null
        },
        name: {
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        maxLength: {
            type: Number
        },
        large: {
            type: Boolean,
            default: false
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        transform: {
            type: String,
            default: false
        },
        onFocus: {
            type: Function,
            default: null
        },
        onBlur: {
            type: Function,
            default: null
        },
        validateUrls: {
            type: Boolean,
            default: false
        },
        hint: {
            type: String,
            default: null
        },
        hintClass: {
            type: String,
            default: null
        }
    },
    methods: {
        hasLabel () {
            return !!this.label || this.$hasSlot('label')
        },
        hasAppend () {
            return this.$hasSlot('append')
        },
        holderClass () {
            return {
                'input-icon': !!this.iconClass
            }
        },
        inputHolderClass () {
            return {
                'input-icon': !!this.iconClass,
                'input-group': this.hasAppend()
            }
        },
        getHint () {
            if (this.hint) {
                return this.hint
            }
        },
        getHintClass () {
            if (this.hintClass) {
                return this.hintClass
            }
        },
        focus () {
            this.$els.input.focus()
        },
        inputOnBlur (evt) {
            if (this.onBlur) {
                this.onBlur(evt)
            }
        },
        inputOnFocus (evt) {
            if (this.onFocus) {
                this.onFocus(evt)
            }
        }
    },
    data () {
        return {
            fieldName: '',
            inputClass: null
        }
    },
    ready () {
        this.fieldName = this.name || this._props.model.raw

        if (!this.placeholder) {
            this.placeholder = this.label
        }

        if (this.validateUrls) {
            $(this.$els.input).on('blur', () => {
                const input = this.$els.input
                const value = input.value
                if (value.includes('http://')) {
                    let invalids = Array.from(value.matchAll(/(\bhttp:\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/ig)).map((match) => {
                        return `<div>- ${match[1]}</div>`
                    })

                    invalids = R.uniq(invalids).join('\n')

                    toastr.warning(`
                        <div>Você inseriu URLs sem https e isso pode prejudicar o nível de segurança do seu site. Recomendamos que dê preferência para URLs com o protocolo https!</div>
                        <div><b>Links:</b></div>
                        ${invalids}
                        <div style="margin-top: 10px">
                            <button class="btn default btn-sm go-to-field">ir para o campo</button>
                        </div>
                    `, 'Cuidado!', {
                        timeOut: 0,
                        onShown: function () {
                            $(this).find('.go-to-field').on('click', function () {
                                input.focus()
                                $.scrollTo(input, {
                                    offset: -75,
                                    animate: true
                                })
                            })
                        },
                        preventDuplicates: true
                    }).width(300)
                }
            })
        }

        if (this.maxLength) {
            $(this.$els.input).attr('maxlength', this.maxLength)
            $(this.$els.input).maxlength({
                alwaysShow: true,
                warningClass: 'label label-primary',
                limitReachedClass: 'label label-danger',
                separator: ' de ',
                preText: '',
                postText: ' ',
                validate: true
            })
        }

        this.inputClass = ['form-control']

        if (this.large) {
            this.inputClass.push('input-lg')
        }

        this.$nextTick(() => {
            if (this.autofocus) {
                this.focus()
            }
        })
    },
    computed: {
        value: {
            cache: false,
            get () {
                return this.model
            },
            set (val) {
                try {
                    if (val === null) {
                        // ignores
                    } else if (val === '' || val === undefined) {
                        this.model = null
                    } else {
                        let result = transform(this.transform || null, val)

                        if (Number.isNaN(result)) {
                            result = null
                        }

                        this.model = result
                    }
                } catch (err) {
                    this.model = null
                }
            }
        }
    },
    watch: {
        model (newVal, oldVal) {
            console.log('watch.model', { newVal, oldVal })
        }
    },
    template: `
            <div class="form-group">
                <form-label v-if="hasLabel()" :hint="getHint()" :hint-class="getHintClass()">
                    <slot name="label">
                        {{ label }}
                    </slot>
                </form-label>
                <div v-bind:class="holderClass()">
                    <i v-bind:class="iconClass" v-if="iconClass"></i>
                    <div v-bind:class="inputHolderClass()">
                        <input v-el:input
                               v-on:blur="inputOnBlur($event)"
                               v-on:focus="inputOnFocus($event)"
                               type="text"
                               v-bind:class="inputClass"
                               v-bind:placeholder="placeholder"
                               v-model="value"
                               v-bind:data-field="fieldName"
                               v-bind:disabled="disabled"
                               v-bind:readonly="readonly"
                               :autofocus="false">
                        <slot name="append"></slot>
                   </div>
                </div>
                <form-errors :fields="[fieldName]" :on-error="focus"></form-errors>
            </div>
        `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/text.js